
function closeModal(element){

const modalOverlay = document.querySelector(".dynamic-modal-overlay");
const modal = document.querySelector(".dynamic-modal");

document.body.removeChild(modalOverlay);
document.body.removeChild(modal);



}


//opens the modal
function openModal(functionname, parentclass, parentId, modifier, fielddata) {

    //container which the dynamic content will be inserted into
    let contentContainer;

    let modalExists = document.getElementById('dynamic-modal-container');

    if (!modalExists) {
        // only create the modal if it does not exist already
        let overlay = document.createElement('div');
        overlay.className = 'dynamic-modal-overlay';
        overlay.id = 'dynamic-modal-container';
        document.body.appendChild(overlay);

        // create the modal and attach to body
        let modal = document.createElement('div');
        modal.className = 'dynamic-modal';



        let closeWrapper = document.createElement("div");
        closeWrapper.classList.add("modal__Close__Wrapper");
        closeWrapper.innerHTML = `
        
         <span class="modal__closeIcon" onclick="closeModal(this)">&times;</span>
        
        `;

        modal.appendChild(closeWrapper);


        overlay.addEventListener("click",() => {

            closeModal(this);

        })

        document.body.appendChild(modal);


      // create the content
        if(parentclass != ""){

            contentContainer = document.createElement("div");
            contentContainer.classList.add(parentclass);
            contentContainer.setAttribute("id", parentId);
            modal.appendChild(contentContainer);

            let content;

            if(functionname == "createForm"){
          
              
            createForm(parentId, fielddata, modifier);
            


            }

          if(functionname == "cartFreebee"){


            let contentContainer = document.createElement("div");
            contentContainer.classList.add("freebee-container");
            contentContainer.innerHTML = `

          <h2 class="freebee-headline">Unser Geschenk für dich:</h2>
          <p class="freebee-text">Das Festival Special des OMR Reports – jetzt kostenlos als PDF! Fachwissen, Best Practices zu KI, LinkedIn Personal Branding, SEO und Community-Management.</p>
          <img loading="lazy" class="freebee-image" src="https://cdn.shopify.com/s/files/1/0563/4310/1600/files/festival-special-400x.png?v=1746435869" alt="KI prompts im Marketing" />
          <a href="#" class="freebee-cta" onclick="addFreebeeToCart()">Gratis in den Warenkorb legen</a>    

          `;

            modal.appendChild(contentContainer);
          
            
          }


        }
      
        var pdpTnFormContainer = document.getElementById("TN-Form-Dialog");
        if(pdpTnFormContainer){
        var demoCampusCloseButton = document.querySelector(".modal__closeIcon ");
        demoCampusCloseButton.addEventListener("click", e =>{
          
           pdpTnFormContainer.style.zIndex = "unset";
          
        }); 

        var demoCampusSubmitButton = document.getElementById("omr-button_demoCampusModalForm");
        demoCampusSubmitButton.addEventListener("click", e =>{
          
           
          
        });       

      }
      
    }


}
  

